import { useEffect, useState } from "react";

import styles from "../Header.module.scss";

const threshold = parseInt(styles.mainNavHeight) + 1;

export function useIsAtTopOfPage() {
    const [isAtTop, setIsAtTop] = useState(
        /* v8 ignore next -- @preserve */
        typeof window === "undefined" ? true : window.scrollY <= threshold,
    );

    useEffect(() => {
        const onScroll = () => setIsAtTop(window.scrollY <= threshold);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return isAtTop;
}
